import React from 'react'

const WithForwardRef = WrappedComponent =>
    React.forwardRef((props, ref) => {
        return <WrappedComponent forwardRef={ref} {...props} />
    })

export default WithForwardRef
